import { useFetchAnyWorkspacePermissions } from '~/hooks/useFetchAnyWorkspacePermissions';
import { useCanViewPrivateAddOn } from '~/swr-hooks/workspaces/addOns/useCanViewPrivateAddOn';
import { canViewAddOns } from '~/utils/permissions/workspacePermissions';

/** Libraries-off workspaces still get this card; the title says boards instead of libraries. */
export const usePrivateWorkspaceAgentFindDuplicatesPromptCard = () => {
  const { data: permissions, isLoading: isPermissionsLoading } = useFetchAnyWorkspacePermissions();
  const { canViewAddOn: isLibrariesEnabled, isLoading: isAddOnsLoading } = useCanViewPrivateAddOn({
    key: 'libraries',
  });
  const canCheckAddOns = canViewAddOns(permissions);

  return {
    isPending: isPermissionsLoading || (canCheckAddOns && isAddOnsLoading),
    title: canCheckAddOns && isLibrariesEnabled ? 'Find duplicates across libraries' : 'Find duplicates across boards',
  };
};
